export default function pluralise(value, unit) {
  return `${unit}${unit && parseFloat(value) <= 1 ? "" : "s"}`;
}
